import styled from 'styled-components';

const TagContainer = styled.div`
  div {
    > *:first-child {
      margin-right: ${({ theme }) => theme.spacing(1)};
    }
  }
`;

export default TagContainer;
